import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=6893ba1a&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"
import style0 from "./Blog.vue?vue&type=style&index=0&id=6893ba1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893ba1a",
  null
  
)

export default component.exports